/* eslint-disable react/prop-types */
import React, { forwardRef } from 'react';

const IconNavigateNext = forwardRef(function IconNavigateNext({ color = 'currentColor', size = 24, ...others }, ref) {
  return (
    <svg
      fill={color}
      height={size}
      ref={ref}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...others}
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
    </svg>
  );
});

export default IconNavigateNext;
